import React, { useState, useEffect, useCallback, useRef } from "react";
import "./signUp.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import "mdb-ui-kit/css/mdb.min.css"; // For CSS
import "@fortawesome/fontawesome-free/css/all.min.css";
import Typography from "@mui/material/Typography";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Notes from "./header";
import FooterManual from "./footerManual";
import { FaEye, FaEyeSlash, FaEdit } from "react-icons/fa";
import { TextField, Grid, Paper, Alert, Modal, Backdrop } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { FormControlLabel, Radio } from "@mui/material";
import { Link } from "react-router-dom";
import Avatar from '@mui/material/Avatar';

import { useDispatch, useSelector } from 'react-redux'; // ✅ correct source for these hooks
import { setProfileImage, fetchProfileImage } from './store'; // ✅ relative import to your local store

// ==================== COUNTRY CODES DATA ====================
let COUNTRY_CODES = [];

// ==================== COUNTRY CODE SELECT COMPONENT ====================
// selectedId: countryId se exact country (US/Canada dono +1 hain)
const CountryCodeSelect = ({ value, selectedId, onChange, options = COUNTRY_CODES }) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const inputRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (searchTerm) {
      const term = searchTerm.trim().toLowerCase();
      const filtered = options.filter(item =>
        (item.country || '').toLowerCase().includes(term) ||
        (item.code || '').toLowerCase().includes(term) ||
        (item.isoCode || '').toLowerCase().includes(term) // ISO se search (e.g. "IN", "CL") - null-safe
      );
      // Prioritize country names that start with the search term over those
      // that merely contain it somewhere in the middle (e.g. "in" -> India
      // before Bahrain), keeping the original order within each group.
      // Exact ISO match sabse upar (e.g. "in" -> India, "cl" -> Chile)
      const isoMatch = [];
      const startsWith = [];
      const containsOnly = [];
      filtered.forEach(item => {
        if ((item.isoCode || '').toLowerCase() === term) {
          isoMatch.push(item);
        } else if ((item.country || '').toLowerCase().startsWith(term)) {
          startsWith.push(item);
        } else {
          containsOnly.push(item);
        }
      });
      setFilteredOptions([...isoMatch, ...startsWith, ...containsOnly]);
    } else {
      setFilteredOptions(options);
    }
  }, [searchTerm, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  const handleOpen = () => {
    setOpen(true);
    setSearchTerm('');
    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);
  };

  const handleClose = () => {
    setOpen(false);
    setSearchTerm('');
  };

  const handleSelect = (item) => {
    onChange(item.code, item);
    handleClose();
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange('', null);
    setSearchTerm('');
  };

  // Pehle countryId se, na mile to dial code se
  const selectedItem =
    (selectedId && options.find(item => item.countryId === selectedId)) ||
    options.find(item => item.code === value);
  const isSelectedItem = (item) => !!selectedItem && item === selectedItem;

  return (
    <div ref={containerRef} style={{ position: 'relative', width: '100%' }}>
      <div style={{ position: 'relative' }}>
        <input
          ref={inputRef}
          type="text"
          value={open ? searchTerm : (selectedItem ? `${(selectedItem.isoCode || '').toUpperCase()} ${selectedItem.code}`.trim() : '')}
          onChange={(e) => {
            if (open) {
              setSearchTerm(e.target.value);
            }
          }}
          onClick={handleOpen}
          placeholder="Search country code..."
          readOnly={!open}
          style={{
            width: '100%',
            padding: '16.5px 40px 16.5px 14px',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            fontSize: '16px',
            outline: 'none',
            cursor: open ? 'text' : 'pointer',
            backgroundColor: 'white',
            transition: 'all 0.2s',
            height: '56px',
            ...(open && {
              borderColor: '#5f666bff',
              borderWidth: '2px',
            })
          }}
        />

        {/* Clear button */}
        {value && !open && (
          <button
            onClick={handleClear}
            style={{
              position: 'absolute',
              right: '32px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#9ca3af',
              transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#eb2329';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#9ca3af';
            }}
            type="button"
          >
            <svg
              style={{
                width: '16px',
                height: '16px',
                pointerEvents: 'none'
              }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}

        {/* Dropdown/search icon */}
        <svg
          style={{
            position: 'absolute',
            right: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '20px',
            height: '20px',
            color: open ? '#eb2329' : '#9ca3af',
            pointerEvents: 'none'
          }}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {open ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          )}
        </svg>
      </div>

      {open && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          maxHeight: '300px',
          overflow: 'auto',
          zIndex: 1300,
          marginTop: '4px',
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '6px',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
        }}>
          {filteredOptions.length === 0 ? (
            <div style={{
              padding: '12px 16px',
              color: '#6b7280',
              fontSize: '14px'
            }}>
              No results found
            </div>
          ) : (
            filteredOptions.map((item, index) => (
              <div
                key={`${item.code}-${index}`}
                onClick={() => handleSelect(item)}
                style={{
                  padding: '12px 16px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 500,
                  transition: 'all 0.2s',
                  backgroundColor: isSelectedItem(item) ? 'rgba(235, 35, 41, 0.12)' : 'white',
                  color: isSelectedItem(item) ? '#eb2329' : '#374151',
                  borderBottom: index < filteredOptions.length - 1 ? '1px solid #f3f4f6' : 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = isSelectedItem(item) ? 'rgba(235, 35, 41, 0.2)' : 'rgba(235, 35, 41, 0.08)';
                  e.currentTarget.style.paddingLeft = '20px';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = isSelectedItem(item) ? 'rgba(235, 35, 41, 0.12)' : 'white';
                  e.currentTarget.style.paddingLeft = '16px';
                }}
              >
                {/* ISO code capital me (Admin Profile jaisa) - Windows pe flag emoji letters jaise dikhte the */}
                  <span style={{ fontSize: '13px', fontWeight: 600, minWidth: '28px', color: '#111827' }}>{(item.isoCode || '').toUpperCase()}</span>
                <span>{item.code}</span>
                <span style={{ marginLeft: 'auto', color: isSelectedItem(item) ? '#eb2329' : '#6b7280', fontSize: '13px' }}>
                  {item.country}
                  {isSelectedItem(item) && ' (Selected)'}
                </span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

const MyProfile = () => {
  const handleCountrySelect = (code, item) => {
    // Clean the code to store without '+' for the API
    const cleanCode = code.replace('+', '');
    setSelectedCountryCode(code);
    // Exact country ka id (US/Canada dono +1) - payload me jayega
    setSelectedCountryId(item?.countryId || null);

    // Also update the formData with the cleaned code for API submission
    setFormData((prev) => ({
      ...prev,
      countryCode: cleanCode,
    }));

    // Store in localStorage
    localStorage.setItem('userCountryCode', code);

    // Store the flag code for display
    const countryItem = item || COUNTRY_CODES.find(c => c.code === code);
    if (countryItem) {
      const flagCode = getCountryFlagCode(countryItem.country);
      if (flagCode) {
        localStorage.setItem('userCountryFlag', flagCode);
        setSelected(flagCode);
      }
    }
  };

  // Helper function to get country flag code from country name
  const getCountryFlagCode = (countryName) => {
    const countryMapping = {
      'Algeria': 'DZ', 'American Samoa': 'AS', 'Angola': 'AO', 'Antigua': 'AG',
      'Australia': 'AU', 'Bahamas': 'BS', 'Bahrain': 'BH', 'Bangladesh': 'BD',
      'Barbados': 'BB', 'Belgium': 'BE', 'Benin': 'BJ', 'Bermuda': 'BM',
      'Botswana': 'BW', 'Brunei': 'BN', 'Burkina Faso': 'BF', 'Burundi': 'BI',
      'Cameroon': 'CM', 'Canada': 'CA', 'Cayman Island': 'KY', 'Chile': 'CL',
      'Colombia': 'CO', "Cote D'Ivoire": 'CI', 'Cyprus': 'CY', 'DR Congo': 'CD',
      'Dominica': 'DM', 'Egypt': 'EG', 'Eritrea': 'ER', 'Ethiopia': 'ET',
      'Fiji': 'FJ', 'Finland': 'FI', 'France': 'FR', 'Gabon': 'GA',
      'Gambia': 'GM', 'Germany': 'DE', 'Ghana': 'GH', 'Greece': 'GR',
      'Grenada': 'GD', 'Guadeloupe': 'GP', 'Guinea': 'GN', 'Guyana': 'GY',
      'Haiti': 'HT', 'Hongkong': 'HK', 'India': 'IN', 'Indonesia': 'ID',
      'Ireland': 'IE', 'Jamaica': 'JM', 'Japan': 'JP', 'Kenya': 'KE',
      'Kiribati': 'KI', 'Kuwait': 'KW', 'Lebanon': 'LB', 'Liberia': 'LR',
      'Libya': 'LY', 'Madagascar': 'MG', 'Malawi': 'MW', 'Malaysia': 'MY',
      'Maldives': 'MV', 'Malta': 'MT', 'Marshall Islands': 'MH', 'Martinique': 'MQ',
      'Mauritania': 'MR', 'Mauritius': 'MU', 'Micronesia': 'FM', 'Morocco': 'MA',
      'Mozambique': 'MZ', 'Myanmar': 'MM', 'Namibia': 'NA', 'Nepal': 'NP',
      'Netherland': 'NL', 'Netherlands Antilles': 'BQ', 'New Caledonia': 'NC',
      'New Zealand': 'NZ', 'Nigeria': 'NG', 'Norway': 'NO', 'Oman': 'OM',
      'Pakistan': 'PK', 'Palau': 'PW', 'Panama': 'PA', 'Papua New Guinea': 'PG',
      'Qatar': 'QA', 'Reunion': 'RE', 'Russia': 'RU', 'Rwanda': 'RW',
      'ST. Kitts': 'KN', 'ST. Lucia': 'LC', 'ST. Vincent': 'VC', 'Samoa': 'WS',
      'Saudi Arabia': 'SA', 'Senegal': 'SN', 'Sierra Leone': 'SL', 'Singapore': 'SG',
      'Solomon Islands': 'SB', 'Somalia': 'SO', 'South Africa': 'ZA', 'South Sudan': 'SS',
      'Sri Lanka': 'LK', 'Sudan': 'SD', 'Suriname': 'SR', 'Swaziland': 'SZ',
      'Sweden': 'SE', 'Tahiti': 'PF', 'Tanzania': 'TZ', 'Thailand': 'TH',
      'Togo': 'TG', 'Tonga': 'TO', 'Trinidad & Tobago': 'TT', 'Turkey': 'TR',
      'Tuvalu': 'TV', 'U.A.E': 'AE', 'Uganda': 'UG', 'United Kingdom': 'GB',
      'United States': 'US', 'Vanuatu': 'VU', 'Venezuela': 'VE', 'Yemen': 'YE',
      'Zambia': 'ZM', 'Zimbabwe': 'ZW'
    };
    return countryMapping[countryName] || null;
  };

  const handleClick = () => {
    navigate("/myAccount");
  };

  const [selected, setSelected] = useState("");
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState(null);

  const [formData, setFormData] = useState({
    userMobileNumber: "",
    firstName: "",
    lastName: "",
    email: "",
    dateOfBirth: "",
    gender: "",
    countryCode: "",
  });

  const [allowedCountries, setAllowedCountries] = useState([]);
  const [countryCodes, setCountryCodes] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await fetch(
          "https://car.amar.co.jp/api/authorization/shipping/all-countries",
          { headers: { "Accept-Language": "en" } }
        );
        const data = await res.json();

        // Build COUNTRY_CODES format for CountryCodeSelect component
        const isoToFlag = (iso) => {
          if (!iso) return ''; // kuch countries ka isoCode null aata hai
          return iso.toUpperCase().replace(/./g, (c) =>
            String.fromCodePoint(c.charCodeAt(0) + 127397)
          );
        };
        COUNTRY_CODES = data.map((c) => ({
          code: c.countryPhoneCode,
          country: c.countryName,
          flag: isoToFlag(c.isoCode),
          isoCode: c.isoCode,
          countryId: c.countryId,
        }));
        setCountryCodes([...COUNTRY_CODES]);

        // Build allowedCountries list
        setAllowedCountries(data.map((c) => c.isoCode));
      } catch (err) {
        console.error("Failed to fetch countries:", err);
      }
    };
    fetchCountries();
  }, []);


  const [loading, setLoading] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // New state for modal

  // Section-specific error and success messages
  const [profileError, setProfileError] = useState("");
  const [profileSuccess, setProfileSuccess] = useState("");

  const [imageError, setImageError] = useState("");
  const [imageSuccess, setImageSuccess] = useState("");

  const [passwordError, setPasswordError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [profilePic, setProfilePic] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLocalPreview, setIsLocalPreview] = useState(false);

  // const user = JSON.parse(localStorage.getItem("user") || "{}");
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const savedCountryCode = localStorage.getItem("userCountryCode");

  // Optional: Set selected country early if saved
  if (!selected && savedCountryCode && allowedCountries.includes(savedCountryCode)) {
    setSelected(savedCountryCode);
  }

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const profileImageState = useSelector(state => state.profileImage);

  // Fetch user details when component mounts
  useEffect(() => {
    // ✅ Load saved flag from signup
    const savedFlag = localStorage.getItem('userCountryFlag');
    if (savedFlag && allowedCountries.includes(savedFlag)) {
      setSelected(savedFlag);
    }

    // Load saved country code
    const savedCode = localStorage.getItem('userCountryCode');
    if (savedCode) {
      setSelectedCountryCode(savedCode);
    }

    fetchUserDetails(); // then call API
  }, []);

  const fetchUserDetails = async () => {
    try {
      setLoading(true);
      setProfileError("");

      // Get token from localStorage or sessionStorage
      const token = localStorage.getItem('token') ||
        sessionStorage.getItem('token') ||
        localStorage.getItem('authToken') ||
        sessionStorage.getItem('authToken');

      if (!token) {
        setProfileError("Authentication required. Please log in again.");
        setLoading(false);
        navigate('/login');
        return;
      }

      const response = await fetch('https://car.amar.co.jp/api/authorization/user/get/user/details', {
        method: 'GET',
        headers: {
          'accept': 'application/json',
          'Accept-Language': 'en',
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.status === 401 || response.status === 403) {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        localStorage.removeItem('authToken');
        sessionStorage.removeItem('authToken');
        setProfileError("Your session has expired. Please log in again.");
        setLoading(false);
        navigate('/login');
        return;
      }

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const responseData = await response.json();
      console.log("API Response:", responseData);

      if (responseData.code === 200 && responseData.userDetails) {
        const userData = responseData.userDetails;
        console.log("User Country Code from API:", userData.countryCode); // Debug log

        // Create a direct mapping of country codes to flag codes
        // Use API-fetched COUNTRY_CODES to find isoCode from countryCode
        // FIRST PRIORITY: Use the countryCode from API response if available
        if (userData.countryCode) {
          const displayCode = userData.countryCode.startsWith('+')
            ? userData.countryCode
            : `+${userData.countryCode}`;
          setSelectedCountryCode(displayCode);
          // Backend countryId de to exact country select hogi (US vs Canada)
          setSelectedCountryId(userData.countryId || null);

          // Find isoCode from COUNTRY_CODES (API data) - pehle id se, phir code se
          const matched =
            (userData.countryId && COUNTRY_CODES.find(c => c.countryId === userData.countryId)) ||
            COUNTRY_CODES.find(c => c.code === displayCode);
          if (matched) {
            // Extract isoCode from flag emoji reverse or use flag directly
            const isoCode = matched.isoCode || matched.flag;
            setSelected(isoCode);
            localStorage.setItem('userCountryFlag', isoCode);
          }
        }

        // SECOND PRIORITY: Check localStorage for saved country
        else if (localStorage.getItem('userCountryCode') &&
          allowedCountries.includes(localStorage.getItem('userCountryCode'))) {
          const savedCountry = localStorage.getItem('userCountryCode');
          console.log("Setting country from localStorage:", savedCountry);
          setSelected(savedCountry);
        }
        // THIRD PRIORITY: Parse from mobile number if available
        else if (userData.userMobileNumber && userData.userMobileNumber.startsWith('+')) {
          const numberWithCode = userData.userMobileNumber;
          const matchedByPrefix = COUNTRY_CODES.find(c => numberWithCode.startsWith(c.code));
          if (matchedByPrefix) {
            setSelected(matchedByPrefix.isoCode);
            localStorage.setItem('userCountryCode', matchedByPrefix.isoCode);
          }
        }
        // FINAL FALLBACK: Default to Japan (JP) if nothing else works
        else {
          console.log("Defaulting to Japan (JP)");
          setSelected('JP');
          localStorage.setItem('userCountryCode', 'JP');
        }

        // Rest of your form data setup...
        let mobileNumber = userData.userMobileNumber || "";
        if (mobileNumber.startsWith('+')) {
          const match = mobileNumber.match(/\+\d+[-\s]*(\d+)/);
          if (match && match[1]) {
            mobileNumber = match[1];
          }
        }
        // No need to slice or limit here - keep the full number

        let formattedDob = userData.dateOfBirth || "";
        if (formattedDob.includes('T')) {
          formattedDob = formattedDob.split('T')[0];
        }
        if (formattedDob.match(/^\d{4}-\d{2}-\d{2}$/)) {
          const [year, month, day] = formattedDob.split('-');
          formattedDob = `${day}/${month}/${year}`;
        }

        setFormData({
          firstName: userData.firstName || "",
          lastName: userData.lastName || "",
          email: userData.email || "",
          userMobileNumber: mobileNumber,
          dateOfBirth: formattedDob,
          gender: userData.gender || "",
          countryCode: userData.countryCode?.replace('+', '') || "",
        });

        console.log("Profile data loaded successfully");
      } else {
        console.warn("Unexpected API response format:", responseData);
        setProfileError("Unable to parse user data. Please try again later.");
      }
    } catch (error) {
      console.error("Error in fetchUserDetails:", error);
      setProfileError("An unexpected error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const getAuthToken = useCallback(() => {
    return localStorage.getItem("token") ||
      sessionStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      sessionStorage.getItem("authToken");
  }, []);

  // Debug function to log requests and responses
  const debugFetch = useCallback(async (url, options, logName = "API Call") => {
    try {
      console.log(`${logName} Request:`, { url, options });

      const response = await fetch(url, options);
      console.log(`${logName} Response Status:`, response.status);

      // Clone the response to read it twice
      const responseClone = response.clone();

      try {
        const data = await responseClone.json();
        console.log(`${logName} Response Data:`, data);
      } catch (e) {
        console.log(`${logName} Response is not JSON`);
      }

      return response;
    } catch (error) {
      console.error(`${logName} Error:`, error);
      throw error;
    }
  }, []);

  // Helper function to get initials from name
  const getInitials = useCallback((fullName) => {
    if (!fullName) return "";
    const parts = fullName.trim().split(" ").filter((part) => part.length > 0);
    if (parts.length === 0) return "";
    return parts.length > 1
      ? parts[0][0].toUpperCase() + parts[1][0].toUpperCase()
      : parts[0][0].toUpperCase();
  }, []);

  // Function to get profile image with authentication
  const getProfileImageWithAuth = useCallback(async () => {
    const token = getAuthToken();
    try {
      const response = await fetch(
        `https://car.amar.co.jp/api/authorization/user/get-image/`,
        {
          headers: {
            'accept': 'application/json',
            'Accept-Language': 'en',
            "Authorization": `Bearer ${token}`,
          }
        }
      );

      if (response.ok) {
        const blob = await response.blob();
        const imageUrl = URL.createObjectURL(blob);
        // Cache the image URL in localStorage
        localStorage.setItem("profileImageData", imageUrl);
        return imageUrl;
      }
      return null;
    } catch (error) {
      console.error("Error fetching profile image:", error);
      return null;
    }
  }, [getAuthToken]);

  // Alternative method to try if the first one fails
  const getProfileImageAlternative = useCallback(async (fileName) => {
    const token = getAuthToken();
    try {
      if (!fileName) return null;

      // Some APIs require parameters instead of path
      const imageUrl = `https://car.amar.co.jp/api/authorization/user/get-image?fileName=${encodeURIComponent(fileName)}`;

      console.log("Trying alternative image URL:", imageUrl);

      const response = await debugFetch(imageUrl, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Accept-Language": "en"
        }
      }, "Alternative Image Fetch");

      if (!response.ok) {
        throw new Error(`Failed with alternative method: ${response.status}`);
      }

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      // Cache the image URL in localStorage
      localStorage.setItem("profileImageData", objectUrl);
      return objectUrl;
    } catch (error) {
      console.error("Alternative method failed:", error);
      return null;
    }
  }, [getAuthToken, debugFetch]);

  // Load profile image from the API
  const loadProfileImage = useCallback(async () => {
    const token = getAuthToken();
    if (!token) {
      console.warn("No token available");
      return;
    }

    setLoading(true);

    try {
      // First check for cached image data in localStorage
      const cachedImageData = localStorage.getItem("profileImageData");
      if (cachedImageData) {
        console.log("Using cached profile image");
        setProfilePic(cachedImageData);
      }

      // Then attempt to get the latest image info
      const imageInfoUrl = 'https://car.amar.co.jp/api/authorization/user/get-image';
      const imageInfoResponse = await debugFetch(imageInfoUrl, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Accept-Language": "en",
          "Content-Type": "application/json"
        }
      }, "Image Info");

      if (imageInfoResponse.ok) {
        const imageData = await imageInfoResponse.json();
        console.log("Image info received:", imageData);

        // Check different possible response structures
        const fileName = imageData?.uniqueFileName || imageData?.fileName || imageData?.profileImage;

        if (fileName) {
          console.log("Found image filename:", fileName);
          localStorage.setItem("profileImageFileName", fileName);

          // Try primary method
          let imageUrl = await getProfileImageWithAuth();

          // If primary method fails, try alternative
          if (!imageUrl) {
            console.log("Primary method failed, trying alternative...");
            imageUrl = await getProfileImageAlternative(fileName);
          }

          if (imageUrl) {
            console.log("Successfully got image URL:", imageUrl);
            setProfilePic(imageUrl);
            // Update Redux state
            dispatch(setProfileImage(imageUrl));
          } else {
            console.error("Both image fetch methods failed");
          }
        } else {
          console.warn("No image filename found in response:", imageData);
        }
      } else {
        console.error("Failed to fetch image info:", imageInfoResponse.status);
      }
    } catch (err) {
      console.error("Error loading user data:", err);
    } finally {
      setLoading(false);
    }
  }, [getAuthToken, debugFetch, getProfileImageWithAuth, getProfileImageAlternative, dispatch]);

  // Handle image upload
  const handleImageChange = useCallback(async (event) => {
    const token = getAuthToken();
    const file = event.target.files[0];
    if (!file) return;

    // Validate file
    if (!file.type.startsWith("image/")) {
      setImageError("Please select a valid image file");
      return;
    }

    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      setImageError("Image too large. Max 5MB");
      return;
    }

    // Create a local preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setProfilePic(e.target.result);
    };
    reader.readAsDataURL(file);

    // Upload the image
    const formData = new FormData();
    formData.append("profile-image", file);

    try {
      setLoading(true);
      setImageError("");
      setImageSuccess("");

      if (!token) {
        throw new Error("Authentication token missing. Please log in again.");
      }

      console.log("Uploading image...");

      const uploadUrl = 'https://car.amar.co.jp/api/authorization/user/upload/profile-photo';
      const res = await debugFetch(uploadUrl, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`
        },
        body: formData
      }, "Image Upload");

      if (!res.ok) {
        throw new Error(`Upload failed: ${res.status}`);
      }

      const data = await res.json();
      console.log("Upload response:", data);

      if (data?.uniqueFileName || data?.fileName) {
        const fileName = data?.uniqueFileName || data?.fileName;
        // Store filename in localStorage for persistence
        localStorage.setItem("profileImageFileName", fileName);

        // Get the actual image with auth
        const imageUrl = await getProfileImageWithAuth();
        if (imageUrl) {
          setProfilePic(imageUrl);
          // Update Redux state with new image
          dispatch(setProfileImage(imageUrl));
          setImageSuccess("Uploaded successfully!");

          setTimeout(() => {
            setImageSuccess("");
          }, 3000);
        } else {
          throw new Error("Failed to retrieve the uploaded image");
        }
      } else {
        throw new Error("No filename returned from server");
      }
    } catch (err) {
      console.error("Upload error:", err);
      setImageError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }, [getAuthToken, debugFetch, getProfileImageWithAuth, dispatch]);

  // New function to handle large image view
  const handleImageClick = () => {
    if (profilePic) {
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Load user profile image on component mount
  useEffect(() => {
    loadProfileImage();
  }, [loadProfileImage]);

  // Clean up object URLs on unmount
  useEffect(() => {
    return () => {
      if (profilePic && typeof profilePic === 'string' && profilePic.startsWith('blob:')) {
        URL.revokeObjectURL(profilePic);
      }
    };
  }, [profilePic]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // For mobile number, only allow digits and limit to 15 characters
    if (name === "userMobileNumber") {
      const digitsOnly = value.replace(/\D/g, '');
      if (digitsOnly.length <= 15) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: digitsOnly,
        }));
      }
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const handleChangePassword = async () => {
    if (!currentPassword) {
      setPasswordError("Current password is required.");
      return;
    }

    if (!newPassword) {
      setPasswordError("New password is required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setPasswordError("New password and confirm password do not match.");
      return;
    }

    setPasswordError("");
    setPasswordSuccess("");
    setLoading(true);

    try {
      const token =
        localStorage.getItem("token") ||
        sessionStorage.getItem("token") ||
        localStorage.getItem("authToken") ||
        sessionStorage.getItem("authToken");

      if (!token) {
        setPasswordError("Authentication required. Please log in again.");
        setLoading(false);
        return;
      }

      const passwordPayload = {
        currentPassword,
        newPassword,
        confirmNewPassword: confirmPassword,
      };

      const response = await fetch(
        "https://car.amar.co.jp/api/authorization/user/change-password-by-user",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "Accept-Language": "en",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(passwordPayload),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to change password.");
      }

      setPasswordSuccess("Password updated successfully!");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error("Error changing password:", error);
      setPasswordError(error.message || "Failed to change password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setProfileError("");
    setProfileSuccess("");

    if (!selectedCountryCode) {
      setProfileError("Please select a country code.");
      setLoading(false);
      return;
    }

    if (formData.userMobileNumber) {
      if (formData.userMobileNumber.length < 10) {
        setProfileError("Mobile number must be at least 10 digits.");
        setLoading(false);
        return;
      }
      if (formData.userMobileNumber.length > 15) {
        setProfileError("Mobile number cannot exceed 15 digits.");
        setLoading(false);
        return;
      }
    }

    // Keep + prefix in countryCode
    const countryCode = selectedCountryCode.startsWith('+')
      ? selectedCountryCode
      : `+${selectedCountryCode}`;

    // Convert YYYY-MM-DD → DD/MM/YYYY for backend
    const formatDob = (dob) => {
      if (!dob) return null;
      if (dob.includes('/')) return dob; // already DD/MM/YYYY
      const [yyyy, mm, dd] = dob.split('-');
      if (yyyy && mm && dd) return `${dd}/${mm}/${yyyy}`;
      return null;
    };
    const formattedDob = formatDob(formData.dateOfBirth);

    // Create payload — skip dateOfBirth if empty
    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      gender: formData.gender,
      userMobileNumber: formData.userMobileNumber,
      countryCode: countryCode,
      // Backend countryId se exact country save karta hai
      countryId: selectedCountryId || COUNTRY_CODES.find(c => c.code === countryCode)?.countryId || null,
      ...(formattedDob ? { dateOfBirth: formattedDob } : {}),
    };

    let token = localStorage.getItem('token') ||
      sessionStorage.getItem('token') ||
      localStorage.getItem('authToken') ||
      sessionStorage.getItem('authToken');

    if (!token) {
      setProfileError("Authentication required. Please log in again.");
      setLoading(false);
      return;
    }

    try {
      console.log("Sending update with payload:", payload);

      const response = await fetch('https://car.amar.co.jp/api/authorization/user/update-user-details-by-user', {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Accept-Language': 'en',
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (response.status === 401 || response.status === 403) {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        localStorage.removeItem('authToken');
        sessionStorage.removeItem('authToken');

        setProfileError("Your session has expired. Please log in again.");
        setLoading(false);
        navigate('/login');
        return;
      }

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Failed to update profile: ${errorData.message || response.status}`);
      }

      const responseData = await response.json();
      console.log("Update response:", responseData);

      setProfileSuccess("Profile updated successfully!");
      const timer = setTimeout(() => {
        setProfileSuccess("");
      }, 3000);

      // Store selected country code for future use
      localStorage.setItem('userCountryCode', selectedCountryCode);

    } catch (error) {
      console.error("Error updating profile:", error);
      setProfileError("Failed to update profile. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      className="container-main-AllSeeModels"
      sx={{
        position: "relative",
        width: "100%", // Ensure it uses available space if maxWidth isn't reached
      }}
    >
      {/* <HeaderManual></HeaderManual> */}
      <Notes />

      <Box
        className="image-container-MyProfile"
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "30vh", sm: "40vh", md: "50vh" },
          backgroundColor: "black",
        }}
      >
        <Box
          component="img"
          src="/image/shutterstock.png"
          alt="My Profile Background"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.3,
          }}
        />

        {/* Breadcrumb */}
        <Box
          sx={{
            position: "absolute",
            top: { xs: "5%", sm: "5%", md: "5%" },
            left: { xs: "3%", sm: "5%", md: "5%" },
            margin: 0,
            color: "white",
            fontSize: { xs: "11px", sm: "13px", md: "15px" },
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            padding: { xs: "4px 8px", sm: "5px 10px", md: "5px 10px" },
            borderRadius: "5px",
          }}
        >
          <Typography
            component="span"
            sx={{
              opacity: 0.5,
              marginRight: { xs: "2px", sm: "5px", md: "5px" },
            }}
          >
            <Link
              to="http://3.110.209.177"
              style={{
                fontSize: "inherit",
                color: "white",
                textDecoration: "none",
              }}
            >
              Home/
            </Link>
          </Typography>

          <Link
            to="https://car.amar.co.jp/MyAccount"
            style={{
              fontSize: "inherit",
              color: "white",
              textDecoration: "none",
            }}
          >
            My Account
          </Link>

          / My Profile
        </Box>

        {/* Center Content */}
        <Box
          className="support-paragraph-MyProfile"
          sx={{
            position: "absolute",
            margin: "auto",
            color: "white",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: { xs: "1.5rem", sm: "2rem", md: "30px" },
            fontFamily: "Roboto",
            fontWeight: "700",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: { xs: "10px", sm: "15px", md: "20px" },
            textAlign: "center",
            width: "90%",
          }}
        >
          Welcome!

          <button
            onClick={handleClick}
            style={{
              backgroundColor: "#EB2329",
              color: "white",
              border: "none",
              padding:
                window.innerWidth < 600
                  ? "8px 16px"
                  : window.innerWidth < 960
                    ? "9px 18px"
                    : "10px 20px",
              fontSize:
                window.innerWidth < 600
                  ? "14px"
                  : window.innerWidth < 960
                    ? "15px"
                    : "16px",
              borderRadius: "8px",
              cursor: "pointer",
              textTransform: "uppercase",
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#c41f23")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#EB2329")}
          >
            My Account
          </button>
        </Box>
      </Box>

      <Box className="logo-section-AllSeeModels">
        <Box
          sx={{
            width: "90%",
            backgroundColor: "#FFFFFF",
            border: "2px solid #EBEBEB",
            left: "50%",
            mt: {
              xs: "39px",
              sm: "39px",
              md: "-18px", // 👈 1024px and up
              lg: "-18px",
              xl: "-10px",
            },
            borderRadius: "10px",
            transform: "translate(-50%, -8%)",
            position: "relative",
            padding: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <Grid container spacing={4}>
            {/* Left Column - Profile Picture Upload Section */}
            <Grid item xs={12} sm={12} md={4} sx={{ textAlign: "center" }}>
              <Box
                sx={{
                  width: { xs: 200, sm: 220, md: 250 },
                  height: { xs: 200, sm: 220, md: 250 },
                  borderRadius: "50%",
                  overflow: "hidden",
                  margin: "auto",
                  border: "3px solid #e0e0e0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f9f9f9",
                  "&:hover": {
                    cursor: "pointer",
                    borderColor: "#eb2329",
                  },
                  position: "relative",
                  transition: "all 0.3s ease",
                }}
                onClick={handleImageClick}
              >
                {loading ? (
                  <Typography>Loading...</Typography>
                ) : profilePic ? (
                  <img
                    src={profilePic}
                    alt="Profile"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      console.error("Image failed to load:", e);
                      const savedFileName = localStorage.getItem("profileImageFileName");
                      if (savedFileName) {
                        getProfileImageWithAuth(savedFileName).then(url => {
                          if (url) {
                            e.target.src = url;
                          } else {
                            setProfilePic(null);
                          }
                        });
                      } else {
                        setProfilePic(null);
                      }
                    }}
                  />
                ) : (
                  <Avatar
                    sx={{
                      width: "100%",
                      height: "100%",
                      fontSize: { xs: 32, sm: 40, md: 48 },
                      backgroundColor: "#eb2329",
                    }}
                  >
                    {getInitials(formData?.firstName && formData?.lastName
                      ? `${formData.firstName} ${formData.lastName}`
                      : user?.fullName) || "U"}
                  </Avatar>
                )}

                {/* Edit Icon Overlay */}
                <label
                  htmlFor="profile-upload"
                  style={{
                    position: "absolute",
                    bottom: -5,
                    // right: 10,
                    color: "white",
                    backgroundColor: "#eb2329",
                    borderRadius: "50%",
                    padding: 12,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    zIndex: 10,
                    transition: "transform 0.2s ease-in-out",
                    boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
                    fontSize: "18px",
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.15)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                  onClick={(e) => e.stopPropagation()}
                >
                  <FaEdit />
                  <input
                    type="file"
                    id="profile-upload"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />
                </label>
              </Box>

              {imageError && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {imageError}
                </Alert>
              )}
              {imageSuccess && (
                <Alert severity="success" sx={{ mt: 2 }}>
                  {imageSuccess}
                </Alert>
              )}
            </Grid>

            {/* Middle Column - Profile Form */}
            <Grid item xs={12} sm={12} md={4}>
              <Box sx={{ paddingRight: { xs: 0, md: 2 } }}>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    color: "#eb2329",
                    fontWeight: 700,
                    marginBottom: 3,
                    fontSize: { xs: "1.25rem", md: "1.5rem" }
                  }}
                >
                  Profile
                </Typography>

                {profileError && (
                  <Alert severity="error" sx={{ mb: 2 }}>
                    {profileError}
                  </Alert>
                )}
                {profileSuccess && (
                  <Alert severity="success" sx={{ mb: 2 }}>
                    {profileSuccess}
                  </Alert>
                )}

                <form onSubmit={handleSubmit}>
                  <TextField
                    fullWidth
                    margin="normal"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="First Name"
                    label="First Name *"
                    required
                    disabled={loading}
                    variant="outlined"
                    sx={{
                      marginBottom: 2,
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#e0e0e0",
                        },
                        "&:hover fieldset": {
                          borderColor: "#999",
                        },
                      },
                    }}
                  />

                  <TextField
                    fullWidth
                    margin="normal"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Last Name"
                    label="Last Name *"
                    required
                    disabled={loading}
                    variant="outlined"
                    sx={{
                      marginBottom: 2,
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#e0e0e0",
                        },
                        "&:hover fieldset": {
                          borderColor: "#999",
                        },
                      },
                    }}
                  />

                  <TextField
                    fullWidth
                    margin="normal"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email"
                    label="Email *"
                    required
                    disabled={loading}
                    variant="outlined"
                    sx={{
                      marginBottom: 2,
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#e0e0e0",
                        },
                        "&:hover fieldset": {
                          borderColor: "#999",
                        },
                      },
                    }}
                  />

                  {/* Country Code & Mobile Number - New Searchable Version */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      marginBottom: 2,
                      flexDirection: { xs: "column", sm: "row" }
                    }}
                  >
                    <Box sx={{ flex: '0 0 auto', minWidth: '200px' }}>

                      <CountryCodeSelect
                        value={selectedCountryCode}
                        selectedId={selectedCountryId}
                        onChange={handleCountrySelect}
                        options={countryCodes}
                      />
                    </Box>

                    <Box sx={{ flex: 1 }}>
                      <TextField
                        fullWidth
                        type="text"
                        name="userMobileNumber"
                        value={formData.userMobileNumber || ""}
                        onChange={handleChange}
                        placeholder="Enter your mobile number"
                        label="Mobile Number *"
                        disabled={loading}
                        inputProps={{
                          maxLength: 15,
                          inputMode: 'numeric',
                          pattern: '[0-9]*'
                        }}
                        helperText={
                          formData.userMobileNumber &&
                            formData.userMobileNumber.length > 0 &&
                            formData.userMobileNumber.length < 10
                            ? "Minimum 10 digits required"
                            : formData.userMobileNumber.length > 15
                              ? "Maximum 15 digits allowed"
                              : ""
                        }
                        error={
                          formData.userMobileNumber &&
                          formData.userMobileNumber.length > 0 &&
                          (formData.userMobileNumber.length < 10 || formData.userMobileNumber.length > 15)
                        }
                        variant="outlined"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#fff",
                            height: "56px",
                            "& fieldset": {
                              borderColor: "#e0e0e0",
                              borderWidth: "1px",
                            },
                            "&:hover fieldset": {
                              borderColor: "#999",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#eb2329",
                              borderWidth: "2px",
                            },
                            "&.Mui-error fieldset": {
                              borderColor: "#d32f2f",
                            },
                            "&.Mui-disabled": {
                              backgroundColor: "#f5f5f5",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            color: "#666",
                            "&.Mui-focused": {
                              color: "#eb2329",
                            },
                            "&.Mui-error": {
                              color: "#d32f2f",
                            },
                            "&.Mui-disabled": {
                              color: "#999",
                            },
                          },
                          "& .MuiFormHelperText-root": {
                            marginLeft: 0,
                            fontSize: "0.75rem",
                            color: "#d32f2f",
                          },
                        }}
                      />
                    </Box>
                  </Box>

                  <TextField
                    fullWidth
                    margin="normal"
                    type="date"
                    name="dateOfBirth"
                    value={
                      formData.dateOfBirth && formData.dateOfBirth.includes('/')
                        ? (() => {
                          const [dd, mm, yyyy] = formData.dateOfBirth.split('/');
                          return `${yyyy}-${mm}-${dd}`;
                        })()
                        : formData.dateOfBirth
                    }
                    onChange={(e) => {
                      const dateVal = e.target.value;
                      const [yyyy, mm, dd] = dateVal.split("-");
                      handleChange({
                        target: {
                          name: "dateOfBirth",
                          value: `${dd}/${mm}/${yyyy}`,
                        },
                      });
                    }}
                    InputLabelProps={{ shrink: true }}
                    label="Date of Birth"
                    disabled={loading}
                    variant="outlined"
                    sx={{
                      marginBottom: 2,
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#e0e0e0",
                        },
                        "&:hover fieldset": {
                          borderColor: "#999",
                        },
                      },
                    }}
                  />

                  {/* Gender */}
                  <Box sx={{ display: "flex", gap: 3, mt: 2, mb: 3 }}>
                    <FormControlLabel
                      control={
                        <Radio
                          checked={formData.gender === "Male"}
                          onChange={handleChange}
                          value="Male"
                          name="gender"
                          disabled={loading}
                        />
                      }
                      label="Male"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          checked={formData.gender === "Female"}
                          onChange={handleChange}
                          value="Female"
                          name="gender"
                          disabled={loading}
                        />
                      }
                      label="Female"
                    />
                  </Box>

                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      backgroundColor: "#eb2329",
                      color: "white",
                      padding: "12px",
                      fontWeight: 600,
                      fontSize: "1rem",
                      textTransform: "uppercase",
                      "&:hover": {
                        backgroundColor: "#d02026",
                      },
                      "&:disabled": {
                        backgroundColor: "#ccc",
                        color: "#999",
                      },
                    }}
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save Profile"}
                  </Button>
                </form>
              </Box>
            </Grid>

            {/* Right Column - Change Password Section */}
            <Grid item xs={12} sm={12} md={4}>
              <Paper
                elevation={0}
                sx={{
                  padding: 3,
                  border: "1px solid #e0e0e0",
                  borderRadius: 1,
                  backgroundColor: "#fff",
                  height: "100%",
                }}
              >
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    color: "#eb2329",
                    fontWeight: 700,
                    marginBottom: 3,
                    fontSize: { xs: "1.25rem", md: "1.5rem" }
                  }}
                >
                  Change Password
                </Typography>

                {passwordError && (
                  <Alert severity="error" sx={{ mb: 2 }}>
                    {passwordError}
                  </Alert>
                )}
                {passwordSuccess && (
                  <Alert severity="success" sx={{ mb: 2 }}>
                    {passwordSuccess}
                  </Alert>
                )}

                <TextField
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  margin="normal"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  placeholder="Current Password"
                  label="Current Password *"
                  required
                  disabled={loading}
                  variant="outlined"
                  sx={{
                    marginBottom: 2,
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#e0e0e0",
                      },
                      "&:hover fieldset": {
                        borderColor: "#999",
                      },
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <Box
                        sx={{
                          cursor: "pointer",
                          ml: 1,
                          display: "flex",
                          alignItems: "center",
                          color: "#666",
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </Box>
                    ),
                  }}
                />

                <TextField
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  margin="normal"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="New Password"
                  label="New Password *"
                  required
                  disabled={loading}
                  variant="outlined"
                  sx={{
                    marginBottom: 2,
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#e0e0e0",
                      },
                      "&:hover fieldset": {
                        borderColor: "#999",
                      },
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <Box
                        sx={{
                          cursor: "pointer",
                          ml: 1,
                          display: "flex",
                          alignItems: "center",
                          color: "#666",
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </Box>
                    ),
                  }}
                />

                <TextField
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  margin="normal"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm Password"
                  label="Confirm Password *"
                  required
                  disabled={loading}
                  variant="outlined"
                  sx={{
                    marginBottom: 3,
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#e0e0e0",
                      },
                      "&:hover fieldset": {
                        borderColor: "#999",
                      },
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <Box
                        sx={{
                          cursor: "pointer",
                          ml: 1,
                          display: "flex",
                          alignItems: "center",
                          color: "#666",
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </Box>
                    ),
                  }}
                />

                <Button
                  fullWidth
                  variant="contained"
                  sx={{
                    backgroundColor: "#eb2329",
                    color: "white",
                    padding: "12px",
                    fontWeight: 600,
                    fontSize: "1rem",
                    textTransform: "uppercase",
                    "&:hover": {
                      backgroundColor: "#d02026",
                    },
                    "&:disabled": {
                      backgroundColor: "#ccc",
                      color: "#999",
                    },
                  }}
                  onClick={handleChangePassword}
                  disabled={loading || !currentPassword || !newPassword || !confirmPassword}
                >
                  {loading ? "Updating..." : "Update"}
                </Button>
              </Paper>
            </Grid>
          </Grid>

          {/* Large View Modal for Profile Image */}
          <Modal
            open={isModalOpen}
            onClose={handleCloseModal}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Box
              onClick={handleCloseModal}
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: '90vw',
                maxHeight: '90vh',
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 2,
                borderRadius: 2,
                textAlign: 'center',
                cursor: 'pointer',
              }}
            >
              {profilePic && (
                <img
                  src={profilePic}
                  alt="Profile in large view"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    display: 'block',
                    margin: 'auto',
                    borderRadius: '8px',
                  }}
                />
              )}
            </Box>
          </Modal>
        </Box>
      </Box>

      {/* Large View Modal for Profile Image */}
      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Box
          onClick={handleCloseModal}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '90vw',
            maxHeight: '90vh',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            textAlign: 'center',
            cursor: 'pointer',
          }}
        >
          {profilePic && (
            <img
              src={profilePic}
              alt="Profile in large view"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                display: 'block',
                margin: 'auto',
              }}
            />
          )}
        </Box>
      </Modal>

      <FooterManual />
    </Box>
  );
};

export default MyProfile;